const API_BASE = process.env.REACT_APP_IS_ALL_LOCAL === "true"
    ? process.env.REACT_APP_LOCAL_SERVER_HOST
    : process.env.REACT_APP_PROD_SERVER_HOST;

/**
 * Export buckets to Google Tasks
 * @param {Array} buckets - Array of bucket objects to export
 * @param {Array} allBuckets - All buckets for finding children of exported buckets
 * @param {string} timeFrame - Current timeframe (Day, Week, etc.)
 * @returns {Promise} - Response with count and created tasks
 */
export async function exportToGoogleTasks(buckets, allBuckets, timeFrame) {
    try {
        console.log(`[Google Tasks Service] Exporting ${buckets.length} buckets with timeframe: ${timeFrame}`);

        const response = await fetch(`${API_BASE}/api/tasks/export`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                buckets,
                allBuckets,
                timeFrame
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));

            if (response.status === 401) {
                throw new Error(errorData.error || 'Authentication failed. Please log in again.');
            }

            if (response.status === 403) {
                throw new Error(errorData.error || 'Permission denied. Please grant Google Tasks access.');
            }

            throw new Error(errorData.error || 'Failed to export to Google Tasks');
        }

        const data = await response.json();
        console.log(`[Google Tasks Service] Successfully exported ${data.count} tasks`);

        return data;
    } catch (error) {
        console.error('[Google Tasks Service] Error exporting to Google Tasks:', error);
        throw error;
    }
}
